import React, { type ReactNode } from 'react'

function WrongCheckQuizIcon(props: React.ComponentPropsWithoutRef<'svg'>): ReactNode {
  return (
    <svg
      enableBackground="new 0 0 24 24"
      height="15"
      viewBox="0 0 24 24"
      width="15"
      xmlns="http://www.w3.org/2000/svg"
      fill="var(--color-icon-danger)"
      {...props}
    >
      <path d="m18 2c2.206 0 4 1.794 4 4v12c0 2.206-1.794 4-4 4h-12c-2.206 0-4-1.794-4-4v-12c0-2.206 1.794-4 4-4zm0-2h-12c-3.314 0-6 2.686-6 6v12c0 3.314 2.686 6 6 6h12c3.314 0 6-2.686 6-6v-12c0-3.314-2.686-6-6-6z" />
      <path d="m9.957 17c-.253 0-.505-.096-.7-.286l-2.857-2.8c-.394-.386-.4-1.019-.014-1.414.387-.395 1.021-.4 1.414-.015l2.157 2.115 6.442-6.314c.395-.386 1.028-.382 1.414.014.387.394.381 1.028-.013 1.414l-7.143 7c-.195.19-.447.286-.7.286z" />
    </svg>
  )
}

export default WrongCheckQuizIcon
